import { c as _c } from "react/compiler-runtime";
import { LinkButton, LoadingSpinner, PageShell } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type ProcessingOverlayProps = {
  title: string;
  subtitle: string;
  onCancel: () => void;
  isCanceling?: boolean;
};
const ProcessingOverlay = t0 => {
  const $ = _c(12);
  const {
    title,
    subtitle,
    onCancel,
    isCanceling
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "transfer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LoadingSpinner size="xlarge" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isCanceling || $[5] !== onCancel || $[6] !== t3) {
    t4 = <div className="flex flex-col items-center justify-center gap-6">{t2}<LinkButton onClick={onCancel} disabled={isCanceling}>{t3}</LinkButton></div>;
    $[4] = isCanceling;
    $[5] = onCancel;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== subtitle || $[9] !== t4 || $[10] !== title) {
    t5 = <PageShell title={title} subtitle={subtitle}>{t4}</PageShell>;
    $[8] = subtitle;
    $[9] = t4;
    $[10] = title;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default ProcessingOverlay;
function _temp($) {
  return $.processing.cancel;
}